import Vue from "vue";
import Vuex from "vuex";
import API from "../api";

const _ = require("lodash");

Vue.use(Vuex);

async function HandleError(callback) {
	try {
		return await callback();
	} catch (e) {
		if (e.response) throw e.response.data;
		throw e
	}
}
const Manager = {
	namespaced: true,
	state: {
		userList: {}, // 用戶清單（pagination）
		accountList: [],
		formData: {},
		roleList: [{
			label: "管理員",
			value: "manager"
		}, {
			label: "編輯者",
			value: "editor"
		}, {
			label: "評審",
			value: "judge"
		}],
		groupList: ['總籌行政組', '課程服務組', '公共事務組', '使用者經驗組'],
		officialRoutes: [
			// { label: "管理最新消息", value: "", roles: ["admin", "manager", "editor"] },
			// { label: "管理Banner", value: "", roles: ["admin", "manager", "editor"] },
			// { label: "管理解決問題的故事", value: "", roles: ["admin", "manager", "editor"] },
			// { label: "管理熱門關鍵字", value: "", roles: ["admin", "manager", "editor"] },
			// { label: "管理關於 DFC Taiwan", value: "", roles: ["admin", "manager", "editor"] },
			// { label: "管理媒體報導", value: "" }
		],
		challengeRoutes: [
			{ label: "管理平台公佈欄", value: "billboardManage", roles: ["admin", "manager", "editor"] },
			{ label: "管理挑戰報名資料", value: "storiesManage", roles: ["admin", "manager", "editor"] },
			{ label: "管理通知", value: "manageNotificationList", roles: ["admin", "manager", "editor"] },
			// { label: "管理教學資源", value: "freeResourceManage", roles: ["admin", "manager", "editor"] },
			{ label: "管理會員資料", value: "manageMemberList", roles: ["admin", "manager", "editor"] },
			{ label: "管理學校單位", value: "manageSchoolList", roles: ["admin", "manager", "editor"] },
			// { label: "管理挑戰時程", value: "", roles: ["admin", "manager", "editor"] },
			{ label: "管理評審平台", value: "judgeStoriesList", roles: ["admin", "judge"] },
			// { label: "行為紀錄", value: "", roles: ["admin", "manager", "editor"] },
			{ label: "帳號與權限設定", value: "permissionManage", roles: ["admin"] }
		]
	},
	mutations: {},
	actions: {
		async createManager({ state }, data) {
			await HandleError(async () => {
				let res = (await API.CreateManager(data)).data;
				if (res) state.accountList.push(res);
			});
		},
		async getAccountList({ state }) {
			await HandleError(async () => {
				let arr = (await API.GetAccountList()).data;
				if (arr) state.accountList = _.cloneDeep(arr);
			});
		},
		async deleteAccount({ state }, id) {
			await HandleError(async () => {
				let arr = (await API.DeleteAccout(id)).data;
				if (arr) state.accountList = _.cloneDeep(arr);
			});
		},
		async updateAccount({ state }, data) {
			await HandleError(async () => {
				let arr = (await API.UpdateAccount(data)).data;
				if (arr) state.accountList = _.cloneDeep(arr);
			});
		},
		async getUserList({ state }, data) {
			await HandleError(async () => {
				let res = await API.GetUserList(data);
				state.userList = res.data;
			});
		},
		async getUserInfo({ state }, id) {
			await HandleError(async () => {
				let res = await API.GetUserInfo(id);
				state.formData = res.data;

				// 排序工作經歷
				const list = state.formData.jobs;
				state.formData.jobs = list.length
					&& list.sort((a, b) =>
						a.presently_employed
							? b.end_time - a.end_time
							: b.start_time - a.start_time)
					|| new Array;
			});
		},
		async getAllUsers({ state }) {
			return await HandleError(async () => {
				return (await API.getAllUsers()).data;
			});
		}
	}
};

export default Manager;